import { EPopupGroupActions } from '@r1-frontend/entities/ConnectDomruPopup/context/constants/actions';

import { IAction } from '@r1-frontend/shared/types/Redux';

export const toggleFilter = (filter: string): IAction<EPopupGroupActions.ToggleFilter, { filter: string }> => ({
    type: EPopupGroupActions.ToggleFilter,
    payload: {
        filter,
    },
});
